// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.purchase_orders_admin {
  min-height: 100vh;
}
.purchase_orders_admin .po_main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 90%;
  margin-top: 15vh;
  position: relative;
}
.purchase_orders_admin .po_main .new_order_btn {
  position: absolute;
  right: 0;
  top: 10px;
}
.purchase_orders_admin .po_main .manufacture_btn {
  position: absolute;
  right: 90px;
  top: 10px;
}
.purchase_orders_admin .po_main .purchase_order_filters {
  display: flex;
  justify-content: space-evenly;
  gap: 5px;
}
.purchase_orders_admin .po_main .purchase_order_filters select {
  border-radius: 5px;
  width: 32%;
  height: 4vh;
}
.purchase_orders_admin .po_main .man_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 75%;
  margin: 0 auto;
}
.purchase_orders_admin .po_main .man_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.purchase_orders_admin .po_main .man_table tbody {
  text-align: center;
}
.purchase_orders_admin .po_main .man_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.purchase_orders_admin .po_main .man_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.purchase_orders_admin .po_main .man_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.purchase_orders_admin .po_main .po_status_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  margin-bottom: 5vh;
  width: 100%;
}
.purchase_orders_admin .po_main .po_status_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.purchase_orders_admin .po_main .po_status_table tbody {
  text-align: center;
}
.purchase_orders_admin .po_main .po_status_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.purchase_orders_admin .po_main .po_status_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.purchase_orders_admin .po_main .po_status_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.purchase_orders_admin .po_main .po_status_table .status_cell {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
@media (max-width: 900px) {
  .purchase_orders_admin .po_main .po_status_table {
    display: block;
    /* Hide table headers (but not display: none;, for accessibility) */
  }
  .purchase_orders_admin .po_main .po_status_table thead,
  .purchase_orders_admin .po_main .po_status_table tbody,
  .purchase_orders_admin .po_main .po_status_table th,
  .purchase_orders_admin .po_main .po_status_table td,
  .purchase_orders_admin .po_main .po_status_table tr {
    display: block;
    text-align: right;
  }
  .purchase_orders_admin .po_main .po_status_table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .purchase_orders_admin .po_main .po_status_table tr {
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }
  .purchase_orders_admin .po_main .po_status_table td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    align-items: center;
    padding-right: 5px;
  }
  .purchase_orders_admin .po_main .po_status_table .status_cell {
    justify-content: flex-end;
  }
  .purchase_orders_admin .po_main .po_status_table .name_cell {
    font-size: 0.8rem;
  }
  .purchase_orders_admin .po_main .po_status_table .name_cell::before {
    font-size: 1rem;
  }
  .purchase_orders_admin .po_main .po_status_table td:before {
    position: absolute;
    top: 3px;
    left: 10px;
    font-weight: 700;
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(1):before {
    content: "PO ID";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(2):before {
    content: "Site";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(3):before {
    content: "Submitted by";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(4):before {
    content: "Supplier";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(5):before {
    content: "Submitted on";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(6):before {
    content: "Stock Take Id";
  }
  .purchase_orders_admin .po_main .po_status_table td:nth-of-type(7):before {
    content: "Status";
  }
}
.purchase_orders_admin .po_main .pagination_btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1vw;
}
.purchase_orders_admin .po_main .pagination_btns button {
  width: 100%;
}

.purchase_orders_approval .po_approval_main {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  width: 90%;
  margin-top: 15vh;
  position: relative;
}
.purchase_orders_approval .po_approval_main .stock_take_btn {
  position: absolute;
  top: 10px;
  right: 0;
}
@media (max-width: 930px) {
  .purchase_orders_approval .po_approval_main .stock_take_btn {
    position: relative;
    margin: 0 auto;
    width: 90%;
  }
}
.purchase_orders_approval .po_approval_main .po_header_details {
  width: 90%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.purchase_orders_approval .po_approval_main .po_header_details p span {
  font-weight: 700;
}
@media (max-width: 1200px) {
  .purchase_orders_approval .po_approval_main .po_header_details {
    flex-direction: column;
  }
}

.purchase_order_search {
  display: flex;
  justify-content: space-around;
  gap: 5px;
  width: 100%;
}
.purchase_order_search select {
  width: 50%;
  border-radius: 5px;
  height: 4.5vh;
}

.purchase_order_table,
.purchase_order_table_warehouse {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 100%;
}
.purchase_order_table thead,
.purchase_order_table_warehouse thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.purchase_order_table tbody,
.purchase_order_table_warehouse tbody {
  text-align: center;
}
.purchase_order_table tbody tr,
.purchase_order_table_warehouse tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.purchase_order_table tbody tr:nth-child(odd),
.purchase_order_table_warehouse tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.purchase_order_table tbody tr input,
.purchase_order_table_warehouse tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.purchase_order_table tbody tr td select,
.purchase_order_table tbody tr td input,
.purchase_order_table_warehouse tbody tr td select,
.purchase_order_table_warehouse tbody tr td input {
  border-radius: 5px;
  width: 50%;
  min-width: 70px;
  height: 3vh;
}
.purchase_order_table tbody .row_category_name,
.purchase_order_table_warehouse tbody .row_category_name {
  background-color: #e4ffff !important;
  text-align: center;
  column-span: all;
}

.purchase_order_btns {
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: 10px;
  margin-bottom: 20px;
}
.purchase_order_btns button {
  width: 50%;
}

@media (max-width: 1200px) {
  .purchase_orders_admin .po_main .purchase_order_filters {
    flex-direction: column;
  }
  .purchase_orders_admin .po_main .purchase_order_filters select {
    width: 100%;
  }
  .purchase_order_search,
  .purchase_order_btns {
    flex-direction: column;
  }
  .purchase_order_search button,
  .purchase_order_search select,
  .purchase_order_btns button,
  .purchase_order_btns select {
    width: 100%;
  }
  .purchase_order_table {
    --label-content:"7-day";
    display: block;
    /* Hide table headers (but not display: none;, for accessibility) */
  }
  .purchase_order_table thead,
  .purchase_order_table tbody,
  .purchase_order_table th,
  .purchase_order_table td,
  .purchase_order_table tr {
    display: block;
    text-align: right;
  }
  .purchase_order_table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .purchase_order_table tr {
    border: 1px solid #ccc;
  }
  .purchase_order_table td:not(.heading_td) {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    align-items: center;
    padding: 10px;
    padding-right: 15px;
    padding-left: 150px;
    text-align: right;
  }
  .purchase_order_table .name_cell {
    font-size: 0.8rem;
  }
  .purchase_order_table .name_cell::before {
    font-size: 1rem;
  }
  .purchase_order_table td:before {
    position: absolute;
    top: 3px;
    left: 10px;
    font-weight: 700;
  }
  .purchase_order_table .heading_td {
    text-align: center;
  }
  .purchase_order_table .row_heading {
    display: none;
  }
  .purchase_order_table td:not(.heading_td):nth-of-type(1):before {
    content: "Product";
  }
  .purchase_order_table td:nth-of-type(2):before {
    content: var(--label-content);
  }
  .purchase_order_table td:nth-of-type(3):before {
    content: "Wastage";
  }
  .purchase_order_table td:nth-of-type(4):before {
    content: "Store Stock";
  }
  .purchase_order_table td:nth-of-type(5):before {
    content: "Recommended";
  }
  .purchase_order_table td:nth-of-type(6):before {
    content: "Actual";
  }
  .purchase_order_table td:nth-of-type(7):before {
    content: "Units";
  }
  .purchase_order_table_warehouse {
    display: block;
    /* Hide table headers (but not display: none;, for accessibility) */
  }
  .purchase_order_table_warehouse thead,
  .purchase_order_table_warehouse tbody,
  .purchase_order_table_warehouse th,
  .purchase_order_table_warehouse td,
  .purchase_order_table_warehouse tr {
    display: block;
    text-align: right;
  }
  .purchase_order_table_warehouse thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .purchase_order_table_warehouse tr {
    border: 1px solid #ccc;
  }
  .purchase_order_table_warehouse td:not(.heading_td) {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    align-items: center;
    padding: 10px;
    padding-right: 15px;
    padding-left: 150px;
    text-align: right;
  }
  .purchase_order_table_warehouse .name_cell {
    font-size: 0.8rem;
  }
  .purchase_order_table_warehouse .name_cell::before {
    font-size: 1rem;
  }
  .purchase_order_table_warehouse td:before {
    position: absolute;
    top: 3px;
    left: 10px;
    font-weight: 700;
  }
  .purchase_order_table_warehouse .heading_td {
    text-align: center;
  }
  .purchase_order_table_warehouse .row_heading {
    display: none;
  }
  .purchase_order_table_warehouse td:not(.heading_td):nth-of-type(1):before {
    content: "Product";
  }
  .purchase_order_table_warehouse td:nth-of-type(2):before {
    content: var(--label-content);
  }
  .purchase_order_table_warehouse td:nth-of-type(3):before {
    content: "Wastage";
  }
  .purchase_order_table_warehouse td:nth-of-type(4):before {
    content: "Store Stock";
  }
  .purchase_order_table_warehouse td:nth-of-type(5):before {
    content: "Warehouse";
  }
  .purchase_order_table_warehouse td:nth-of-type(6):before {
    content: "Recommended";
  }
  .purchase_order_table_warehouse td:nth-of-type(7):before {
    content: "Actual";
  }
  .purchase_order_table_warehouse td:nth-of-type(8):before {
    content: "Units";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/purchase_orders/purchase_orders.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EAEI,iBAAA;AAGJ;AADI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAGR;AADQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAGZ;AAAQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAEZ;AACQ;EACI,aAAA;EACA,6BAAA;EACA,QAAA;AACZ;AACY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAChB;AAGQ;EDiGJ,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECqCA,UAAA;EACA,cAAA;AAEZ;ADgGI;EACI,gCAAA;EACA,kBAAA;AC9FR;ADgGI;EACI,kBAAA;AC9FR;AD+FQ;EACI,gCAAA;AC7FZ;AD8FY;EACI,yBAAA;AC5FhB;AD8FY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC5FhB;AAjBQ;ED2FJ,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;EC2CA,kBAAA;EASA,WAAA;AAcZ;ADsEI;EACI,gCAAA;EACA,kBAAA;ACpER;ADsEI;EACI,kBAAA;ACpER;ADqEQ;EACI,gCAAA;ACnEZ;ADoEY;EACI,yBAAA;AClEhB;ADoEY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AClEhB;AAvCY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAyChB;AApCY;EAbJ;IAcQ,cAAA;IAWA,mEAAA;EA6Bd;EAtCc;;;;;IAKI,cAAA;IACA,iBAAA;EAwClB;EApCc;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAsClB;EAnCc;IACI,sBAAA;IACA,mBAAA;EAqClB;EAlCc;IACI,yBAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EAoClB;EAjCc;IACI,yBAAA;EAmClB;EAhCc;IACI,iBAAA;EAkClB;EA/Bc;IACI,eAAA;EAiClB;EA9Bc;IACI,kBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;EAgClB;EA7Bc;IACI,gBAAA;EA+BlB;EA5Bc;IACI,eAAA;EA8BlB;EA3Bc;IACI,uBAAA;EA6BlB;EA1Bc;IACI,mBAAA;EA4BlB;EAzBc;IACI,uBAAA;EA2BlB;EAzBc;IACI,wBAAA;EA2BlB;EAxBc;IACI,iBAAA;EA0BlB;AACF;AAvBQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAyBZ;AAvBY;EACI,WAAA;AAyBhB;;AAlBI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAqBR;AAnBQ;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAqBZ;AApBY;EAJJ;IAKQ,kBAAA;IACA,cAAA;IACA,UAAA;EAuBd;AACF;AApBQ;EACI,UAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAsBZ;AAnBgB;EACI,gBAAA;AAqBpB;AAjBY;EAZJ;IAaQ,sBAAA;EAoBd;AACF;;AAfA;EACI,aAAA;EACA,6BAAA;EACA,QAAA;EACA,WAAA;AAkBJ;AAhBI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AAkBR;;AAdA;;EDpEI,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;EC2MR,WAAA;AAoBJ;ADvFI;;EACI,gCAAA;EACA,kBAAA;AC0FR;ADxFI;;EACI,kBAAA;AC2FR;AD1FQ;;EACI,gCAAA;AC6FZ;AD5FY;;EACI,yBAAA;AC+FhB;AD7FY;;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACgGhB;AAtCgB;;;;EAEI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;AA0CpB;AArCQ;;EACI,oCAAA;EACA,kBAAA;EACA,gBAAA;AAwCZ;;AAnCA;EACI,aAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAsCJ;AApCI;EACI,UAAA;AAsCR;;AAlCA;EAGY;IACI,sBAAA;EAmCd;EAjCc;IACI,WAAA;EAmClB;EA7BE;;IAEI,sBAAA;EA+BN;EA7BM;;;;IAEI,WAAA;EAiCV;EA7BE;IACI,uBAAA;IACA,cAAA;IAWA,mEAAA;EAqBN;EA9BM;;;;;IAKI,cAAA;IACA,iBAAA;EAgCV;EA5BM;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EA8BV;EA3BM;IACI,sBAAA;EA6BV;EA1BM;IACI,yBAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,iBAAA;EA4BV;EAzBM;IACI,iBAAA;EA2BV;EAxBM;IACI,eAAA;EA0BV;EAvBM;IACI,kBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;EAyBV;EAtBM;IACI,kBAAA;EAwBV;EArBM;IACI,aAAA;EAuBV;EApBM;IACI,kBAAA;EAsBV;EAnBM;IACI,6BAAA;EAqBV;EAlBM;IACI,kBAAA;EAoBV;EAjBM;IACI,sBAAA;EAmBV;EAhBM;IACI,sBAAA;EAkBV;EAfM;IACI,iBAAA;EAiBV;EAdM;IACI,gBAAA;EAgBV;EAZE;IACI,cAAA;IAWA,mEAAA;EAIN;EAbM;;;;;IAKI,cAAA;IACA,iBAAA;EAeV;EAXM;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAaV;EAVM;IACI,sBAAA;EAYV;EATM;IACI,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,iBAAA;EAWV;EARM;IACI,iBAAA;EAUV;EAPM;IACI,eAAA;EASV;EANM;IACI,kBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;EAQV;EALM;IACI,kBAAA;EAOV;EAJM;IACI,aAAA;EAMV;EAHM;IACI,kBAAA;EAKV;EAFM;IACI,6BAAA;EAIV;EADM;IACI,kBAAA;EAGV;EAAM;IACI,sBAAA;EAEV;EACM;IACI,oBAAA;EACV;EAEM;IACI,sBAAA;EAAV;EAGM;IACI,iBAAA;EADV;EAIM;IACI,gBAAA;EAFV;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../variables.scss\";\n\n.purchase_orders_admin {\n    \n    min-height: 100vh;\n\n    .po_main {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 90%;\n        margin-top: 15vh;\n        position: relative;\n\n        .new_order_btn {\n            position: absolute;\n            right: 0;\n            top: 10px;\n        }\n\n        .manufacture_btn {\n            position: absolute;\n            right: 90px;\n            top: 10px;\n        }\n\n        .purchase_order_filters {\n            display: flex;\n            justify-content: space-evenly;\n            gap: 5px;\n\n            select {\n                border-radius: 5px;\n                width: 32%;\n                height: 4vh;\n            }\n        }\n\n        .man_table {\n            @include table;\n            width: 75%;\n            margin: 0 auto;\n        }\n\n        .po_status_table {\n            @include table;\n            margin-bottom: 5vh;\n\n            .status_cell {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                gap: 5px;\n            }\n\n            width: 100%;\n\n            @media (max-width: 900px) {\n                display: block;\n\n                thead,\n                tbody,\n                th,\n                td,\n                tr {\n                    display: block;\n                    text-align: right;\n                }\n\n                /* Hide table headers (but not display: none;, for accessibility) */\n                thead tr {\n                    position: absolute;\n                    top: -9999px;\n                    left: -9999px;\n                }\n\n                tr {\n                    border: 1px solid #ccc;\n                    margin-bottom: 20px;\n                }\n\n                td {\n                    /* Behave  like a \"row\" */\n                    border: none;\n                    border-bottom: 1px solid #eee;\n                    position: relative;\n                    align-items: center;\n                    padding-right: 5px;\n                }\n\n                .status_cell {\n                    justify-content: flex-end;\n                }\n\n                .name_cell {\n                    font-size: 0.8rem;\n                }\n\n                .name_cell::before {\n                    font-size: 1rem;\n                }\n\n                td:before {\n                    position: absolute;\n                    top: 3px;\n                    left: 10px;\n                    font-weight: 700;\n                }\n\n                td:nth-of-type(1):before {\n                    content: \"PO ID\";\n                }\n\n                td:nth-of-type(2):before {\n                    content: \"Site\";\n                }\n\n                td:nth-of-type(3):before {\n                    content: \"Submitted by\";\n                }\n\n                td:nth-of-type(4):before {\n                    content: \"Supplier\";\n                }\n\n                td:nth-of-type(5):before {\n                    content: \"Submitted on\";\n                }\n                td:nth-of-type(6):before {\n                    content: \"Stock Take Id\";\n                }\n\n                td:nth-of-type(7):before {\n                    content: \"Status\";\n                }\n            }\n        }\n        .pagination_btns {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 1vw;\n\n            button {\n                width: 100%;\n            }\n        }\n    }\n}\n\n.purchase_orders_approval {\n    .po_approval_main {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        gap: 10px;\n        width: 90%;\n        margin-top: 15vh;\n        position: relative;\n\n        .stock_take_btn {\n            position: absolute;\n            top: 10px;\n            right: 0;\n            @media (max-width: 930px) {\n                position: relative;\n                margin: 0 auto;\n                width: 90%;\n            }\n        }\n\n        .po_header_details {\n            width: 90%;\n            display: flex;\n            justify-content: space-between;\n            margin: 0 auto;\n\n            p {\n                span {\n                    font-weight: 700;\n                }\n            }\n\n            @media (max-width: 1200px) {\n                flex-direction: column;\n            }\n        }\n    }\n}\n\n.purchase_order_search {\n    display: flex;\n    justify-content: space-around;\n    gap: 5px;\n    width: 100%;\n\n    select {\n        width: 50%;\n        border-radius: 5px;\n        height: 4.5vh;\n    }\n}\n\n.purchase_order_table,\n.purchase_order_table_warehouse {\n    @include table;\n    width: 100%;\n\n    tbody {\n        tr {\n            td {\n                select,\n                input {\n                    border-radius: 5px;\n                    width: 50%;\n                    min-width: 70px;\n                    height: 3vh;\n                }\n            }\n        }\n\n        .row_category_name {\n            background-color: $background !important;\n            text-align: center;\n            column-span: all;\n        }\n    }\n}\n\n.purchase_order_btns {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n    gap: 10px;\n    margin-bottom: 20px;\n\n    button {\n        width: 50%;\n    }\n}\n\n@media (max-width: 1200px) {\n    .purchase_orders_admin {\n        .po_main {\n            .purchase_order_filters {\n                flex-direction: column;\n\n                select {\n                    width: 100%;\n                }\n            }\n        }\n    }\n\n    .purchase_order_search,\n    .purchase_order_btns {\n        flex-direction: column;\n\n        button,\n        select {\n            width: 100%;\n        }\n    }\n\n    .purchase_order_table {\n        --label-content:\"7-day\";\n        display: block;\n\n        thead,\n        tbody,\n        th,\n        td,\n        tr {\n            display: block;\n            text-align: right;\n        }\n\n        /* Hide table headers (but not display: none;, for accessibility) */\n        thead tr {\n            position: absolute;\n            top: -9999px;\n            left: -9999px;\n        }\n\n        tr {\n            border: 1px solid #ccc;\n        }\n\n        td:not(.heading_td) {\n            /* Behave  like a \"row\" */\n            border: none;\n            border-bottom: 1px solid #eee;\n            position: relative;\n            align-items: center;\n            padding: 10px;\n            padding-right: 15px;\n            padding-left: 150px;\n            text-align: right;\n        }\n\n        .name_cell {\n            font-size: 0.8rem;\n        }\n\n        .name_cell::before {\n            font-size: 1rem;\n        }\n\n        td:before {\n            position: absolute;\n            top: 3px;\n            left: 10px;\n            font-weight: 700;\n        }\n\n        .heading_td {\n            text-align: center;\n        }\n\n        .row_heading {\n            display: none;\n        }\n\n        td:not(.heading_td):nth-of-type(1):before {\n            content: \"Product\";\n        }\n\n        td:nth-of-type(2):before {\n            content: var(--label-content);\n        }\n\n        td:nth-of-type(3):before {\n            content: \"Wastage\";\n        }\n\n        td:nth-of-type(4):before {\n            content: \"Store Stock\";\n        }\n\n        td:nth-of-type(5):before {\n            content: \"Recommended\";\n        }\n\n        td:nth-of-type(6):before {\n            content: \"Actual\";\n        }\n\n        td:nth-of-type(7):before {\n            content: \"Units\";\n        }\n    }\n\n    .purchase_order_table_warehouse {\n        display: block;\n\n        thead,\n        tbody,\n        th,\n        td,\n        tr {\n            display: block;\n            text-align: right;\n        }\n\n        /* Hide table headers (but not display: none;, for accessibility) */\n        thead tr {\n            position: absolute;\n            top: -9999px;\n            left: -9999px;\n        }\n\n        tr {\n            border: 1px solid #ccc;\n        }\n\n        td:not(.heading_td) {\n            border: none;\n            border-bottom: 1px solid #eee;\n            position: relative;\n            align-items: center;\n            padding: 10px;\n            padding-right: 15px;\n            padding-left: 150px;\n            text-align: right;\n        }\n\n        .name_cell {\n            font-size: 0.8rem;\n        }\n\n        .name_cell::before {\n            font-size: 1rem;\n        }\n\n        td:before {\n            position: absolute;\n            top: 3px;\n            left: 10px;\n            font-weight: 700;\n        }\n\n        .heading_td {\n            text-align: center;\n        }\n\n        .row_heading {\n            display: none;\n        }\n\n        td:not(.heading_td):nth-of-type(1):before {\n            content: \"Product\";\n        }\n\n        td:nth-of-type(2):before {\n            content: var(--label-content);\n        }\n\n        td:nth-of-type(3):before {\n            content: \"Wastage\";\n        }\n\n        td:nth-of-type(4):before {\n            content: \"Store Stock\";\n        }\n\n        td:nth-of-type(5):before {\n            content: \"Warehouse\";\n        }\n\n        td:nth-of-type(6):before {\n            content: \"Recommended\";\n        }\n\n        td:nth-of-type(7):before {\n            content: \"Actual\";\n        }\n\n        td:nth-of-type(8):before {\n            content: \"Units\";\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
